import { RectangleLoader } from "../../../../shared";

const Loader = () => {
    return <RectangleLoader width="301px" height="32px" />;
};

export default Loader;
